var exports = {
  "tB": "ContextMenu.module__backdrop___QWJtZG",
  "D8": "ContextMenu.module__contextMenuPositioner___QWJtZG",
  "He": "ContextMenu.module__contextMenu___QWJtZG",
  "KY": "ContextMenu.module__menuScroller___QWJtZG",
  "NC": "ContextMenu.module__menuScrollerContent___QWJtZG",
  "AS": "ContextMenu.module__item___QWJtZG",
  "r9": "ContextMenu.module__disabled___QWJtZG",
  "OR": "ContextMenu.module__danger___QWJtZG",
  "Fx": "ContextMenu.module__itemIcon___QWJtZG",
  "IR": "ContextMenu.module__itemLabel___QWJtZG",
  "Ah": "ContextMenu.module__itemWithShortcut___QWJtZG",
  "g$": "ContextMenu.module__itemShortcut___QWJtZG",
  "ED": "ContextMenu.module__itemShortcutHidden___QWJtZG",
  "dP": "ContextMenu.module__itemLabelContainer___QWJtZG",
  "b": "ContextMenu.module__itemLabelText___QWJtZG",
  "Lo": "ContextMenu.module__itemHint___QWJtZG",
  "fV": "ContextMenu.module__submenuCaret___QWJtZG",
  "me": "ContextMenu.module__separator___QWJtZG",
  "Os": "ContextMenu.module__group___QWJtZG",
  "_0": "ContextMenu.module__selectableSection___QWJtZG",
  "dl": "ContextMenu.module__checkboxItem___QWJtZG",
  "fb": "ContextMenu.module__checkboxIndicator___QWJtZG",
  "kv": "ContextMenu.module__checkbox___QWJtZG",
  "xY": "ContextMenu.module__checkboxChecked___QWJtZG",
  "AM": "ContextMenu.module__groupLabel___QWJtZG",
  "HG": "ContextMenu.module__submenuPopover___QWJtZG",
  "a": "ContextMenu.module__submenuScroller___QWJtZG",
  "pT": "ContextMenu.module__quickReactionsGroup___QWJtZG",
  "gV": "ContextMenu.module__quickReactionItem___QWJtZG",
  "z5": "ContextMenu.module__quickReactionShortcut___QWJtZG",
  "dd": "ContextMenu.module__quickReactionTooltipContent___QWJtZG",
  "Vx": "ContextMenu.module__quickReactionTooltipHint___QWJtZG",
  "hH": "ContextMenu.module__emojiSubmenuIcon___QWJtZG",
  "XN": "ContextMenu.module__emojiSubmenuImg___QWJtZG",
};

module.exports = exports;
